/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ILoyaltySignUpViewProps } from './loyalty-sign-up';

const LoyaltySignUpView: React.FC<ILoyaltySignUpViewProps> = props => {
    const {
        LoyaltySignUp,
        heading,
        memberHeading,
        signInLink,
        signUpText,
        signUpButton,
        detailsLink,
        termsLink,
        loading,
        infoMessageBar
    } = props;

    if (loading) {
        props.context.telemetry.error('LoyaltySignUp data is empty, module wont render');
        return null;
    }

    return (
        <Module {...LoyaltySignUp}>
            {infoMessageBar}
            {memberHeading}
            {heading}
            {detailsLink}
            {signUpText}
            {termsLink}
            {signUpButton}
            {signInLink}
        </Module>
    );
};

export default LoyaltySignUpView;
